import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},

		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPositionY: ({ metaData }) => metaData.backgroundImagePosition?.metaValue,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ metaData }) => metaData.opacity?.toNumber() / 100,
			},
		},

		text: {
			zIndex: 1,
			textAlign: 'center',

			[theme.breakpoints.down('xs')]: {
				textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
			},
		},
	}),
	{ name: 'Banners-Banner7' },
)

export default useStyles
